
import React from "react";
import {
  Card,
  CardHeader,
  CardBody,
  CardTitle,
  InputGroup,
  ListGroup,
  ListGroupItem,
  Input,
  Badge,
  InputGroupAddon,
  InputGroupText,
  Row,
  Col,
  UncontrolledTooltip,
 } from "reactstrap";
import {
  Link
} from "react-router-dom";
import PanelHeader from "components/PanelHeader/PanelHeader.jsx";
import { convertTextToTitleCase } from "../../settings/shared/commonMethod"
import SchedulerService from '../../services/api/Scheduler';
import UserService from '../../services/api/User';
import { toast } from 'react-toastify';
import LoadingOverlay from 'react-loading-overlay';
import ScaleLoader from "react-spinners/ScaleLoader";
import moment from 'moment'
import "react-sweet-progress/lib/style.css"; 
import { confirmAlert } from 'react-confirm-alert'; // Import
import 'react-confirm-alert/src/react-confirm-alert.css'; // Import css
import SchedulerNoPopup from "components/Scheduler/SchedulerNopopup";
import { Scrollbars } from 'react-custom-scrollbars';
import { uuidv4 } from "components/Notebook/operations/notebook";
import Pagination from "../../assets/js/Pagination";

class SchedulerList extends React.Component { 
  constructor(props) {
    super(props);
    this.onPageChange = this.onPageChange.bind(this);

    this.state = {
      clusterK8sDTOS:[],
      columns:[],
      percent:'70',
      startcluster:false,
      startindex:0,
      socketLoadFlag: false,
      fileSearch:"",
      SchedulerId:"",
      showScheduler:false,
      schedulerData:[],
      mouseHoverScheduler:"",
      selectedSchedulerId:undefined,
      schedulerDataById:[],
      loadingFlag:"",
      editFlag:true,
      emptyState:"",
      currentPageNumber:0,
      totalPages:0,
      fullViewInfo:false,
      swidth: window.innerWidth,
      sheight: window.innerHeight,
      userList : []
      };
      this.updateWindowDimensions = this.updateWindowDimensions.bind(this);

      this.state.columns = [
        {
        Header: 'Id',
        accessor: 'Id',
        sortable: true,
        show: false
      }, 
      {
      Header: 'Name',
      accessor: 'Name',
      sortable: true,
       }, 
      {
      Header: 'Schedule Type',
      accessor: 'scheduleType',

    },
    {
        Header: 'Created By',
        accessor: 'Created',
      },
    {
      Header: 'Actions',
      accessor: 'Actions',
    }

  ];

};
  
  componentDidMount() {
    this.updateWindowDimensions();
    window.addEventListener('resize', this.updateWindowDimensions);
   this.GetAllUsers();
   var urlSearchParams = new URLSearchParams(window.location.search);
   var params = Object.fromEntries(urlSearchParams.entries());
   if(Object.keys(params).length !== 0){
    const urlSearchParams = new URLSearchParams(window.location.search);
    const params = Object.fromEntries(urlSearchParams.entries());
    if(params.page !== undefined){
      this.setState({
        currentPageNumber:parseInt(params.page)
      })
      this.props.history.push("/schedule");
    }
    if(params.scheduleFor !== undefined){
      this.setState({
        fullViewInfo:true,
        selectedSchedulerId:params.id
      },()=>{
        this.getSchedulerById();
      })
    }else{
      this.setState({
        fullViewInfo:false,
        selectedSchedulerId:params.id
      },()=>{
        this.getSchedulerById();
      })
    }
    
   }
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.updateWindowDimensions);
  }
  
  updateWindowDimensions() {
    this.setState({ swidth: window.innerWidth, sheight: window.innerHeight});
  }

  movetoCreateScheduler = () =>{
    this.props.history.push('/project');
  }

  GetAllSchedulerByPage  = () =>{
    this.setState({ loading: true });
    SchedulerService.getAllScheduer(this.state.currentPageNumber,12)
    .then((response) => {
        this.setState({
          loading: false,
          totalPages:response.schedulerDTOPage.totalPages,
          schedulerData:response.schedulerDTOPage.content
        });
      // } else {
      //     this.setState({loading: false}); 
      //     toast.error(response.errorMessage);
      // }
    })
  }

  onPageChange = (pageIndex) =>{
    this.setState({
      currentPageNumber: pageIndex
    },()=>{
      this.GetAllSchedulerByPage();
    });
  }


onSearchFiles = (value) => {
  if (value === "") {
    this.setState({
      fileSearch: value
    })
  } else {
    this.setState({
      fileSearch: value
    })
  }
}


onEditScheduler = (id) =>{
   this.setState({
     editFlag:false
   },()=>{
    //  this.toggleScheduler();
   })
}

onExpandRunDetails = (id) =>{
  this.props.history.push("/viewScheduler?id="+id+"&page="+this.state.currentPageNumber)
}

onCancelSchedulerConfirmation = () =>{
  confirmAlert({
    title: <h5>Cancel Scheduler</h5>,
    message: 'Are you sure to cancel scheduler?',
    buttons: [
      {
        label: 'Yes',
        onClick: () => this.cancelScheduler()
      },
      {
        label: 'No',
        onClick: () => {
        }
      }
    ]
  });
}

cancelScheduler = () =>{
  this.setState({ loading: false });
  SchedulerService.cancelSchedulerById(this.state.selectedSchedulerId)
  .then((response) => {
    if (response.status === 'SUCCESS') {
      this.setState({
        loading: false,
      });
          toast.success(<i className="fas fa-check-circle">&nbsp; <b className="toast-txt">Scheduler Cancelled Successfully!</b></i>); 
          this.GetAllSchedulerByPage();
        } else {
          this.setState({loading: false}); 
          toast.error(<i className="fas fa-times-circle">&nbsp; <b className="toast-txt">{response.errorMessage}</b></i>); 
        }
  }).catch((error) => {
    this.setState({loading: false}); 
  })
}

RestartClusterConfirmation = (id,name) => {
  confirmAlert({
    title: <h5>Restart Cluster</h5>,
    message: 'Are you sure to restart this cluster? - '+name,
    buttons: [
      {
        label: 'Yes',
        onClick: () => this.RestartCluster(id)
      },
      {
        label: 'No',
        onClick: () => {
        }
      }
    ]
  });
}


toggleScheduler = () => {
  this.setState({
    showScheduler: !this.state.showScheduler,
  });
};

onMouseHoverScheduler = (id) =>{
    this.setState({
      mouseHoverScheduler: id
    })
}

onSchedulerRowClick = (id) =>{
    this.setState({
      editFlag:true,
      selectedSchedulerId: id,
      fullViewInfo:false
    },()=>{
      if(id !== undefined){
        this.getDatabyId(id);
      }
    })
}

getDatabyId = (id) =>{
  let filterDatabyId = this.state.schedulerData.filter(item => item.id === id)
  if(filterDatabyId.length > 0){
    this.setState({
      schedulerDataById:filterDatabyId[0]
    })
  }
}

UpdateScheduleProject = (scheduleDo,type) => {
  //event.preventDefault();
  this.setState({ loading: true });
    SchedulerService.updateScheduler(scheduleDo,this.state.selectedSchedulerId)
    .then((response) => {
      if (response.status === 'SUCCESS') {
        this.setState({
          loading: false,
          schedulerDataById:response.schedulerDTOS[0],
          schedulerDeatails:response.schedulerDTOS[0].scheduleOn
        },()=>{
          this.GetAllSchedulerByPage();
        });
          } else {
            this.setState({loading: false}); 
            toast.error(<i className="fas fa-times-circle">&nbsp; <b className="toast-txt">{response.errorMessage}</b></i>); 
          }
    }).catch((error) => {
      this.setState({loading: false}); 
    })
};

schedulerStatusReplaceWithHypen = (text) =>{
   var replaceText = "";
   replaceText = text.replace("_"," ")
   return replaceText;
}

GetAllUsers  = () => {
  UserService.getAllUsers(localStorage.getItem("Uid"))
  .then((response) => {
    if (response.status === 'SUCCESS') {
      let userDt = response.userDTOS;
      this.setState( { userList:userDt},() =>{
      } );
      }
  })
  this.GetAllSchedulerByPage();
}


getSchedulerById = () =>{
  this.setState({ loadingFlag: "Loading..." });
    SchedulerService.getSchedulerbyId(this.state.selectedSchedulerId)
    .then((response) => {
      if (response.status === 'SUCCESS') {
        this.setState({
          loadingFlag: "",
          schedulerDataById:response.schedulerDTOS[0]
        });
          } else {
            this.setState({loadingFlag: ""}); 
            toast.error(<i className="fas fa-times-circle">&nbsp; <b className="toast-txt">{response.errorMessage}</b></i>); 
          }
    }).catch((error) => {
      this.setState({loadingFlag: ""}); 
    })
}

render() {
    return (
 
      <>
        <PanelHeader
          content={
            <div className="header text-center">           
            </div>
          }
        />
        <div className="content">
        <LoadingOverlay
      active={this.state.loading}
      spinner={<ScaleLoader
        height={35}
        width={5}
        radius={2}
        margin={2}
        color={"#123abc"}
        loading={this.state.loading}
      />}
    >
          <Row>
            <Col xs={12} md={12}>
              <Card>
                <CardHeader>
                <Row className="align-items-center">
                <Col xs="4">
                  <CardTitle tag="h5">Schedulers</CardTitle>
                 </Col>
                 <Col xs="4">
                        <form>
                        <InputGroup className="no-border" style={{ border: "1px solid #d3d3d3",marginBottom:"0px !important" }}>
                          <Input placeholder="Search" disabled onChange={event => this.onSearchFiles(event.target.value)}
                            value={this.state.fileSearch} style={{ color: 'black', height: '30px', fontSize: '14px', backgroundColor: '#fff' }} />

                          <InputGroupAddon addonType="append" style={{ backgroundColor: '#fff', borderRadius: '5px', height: '30px' }}>
                            <InputGroupText style={{ backgroundColor: '#fff', borderRadius: '5px', height: '30px' }}>
                              &nbsp; &nbsp; <i className="now-ui-icons ui-1_zoom-bold" />
                            </InputGroupText>
                          </InputGroupAddon>
                        </InputGroup>
                      </form>
                      </Col>
                  <Col xs="4" className="text-right">
                      <Link to={{
                        pathname: '/schedule',
                        state: { mode: "all" }
                      }}>
                       <span> <i className="fas fa-sync-alt mr-3" onClick={e =>this.GetAllSchedulerByPage()}/></span>
                      </Link>
                    </Col>
                </Row>
                  
                </CardHeader>
                <CardBody>
                <Scrollbars autoHeight autoHeightMin={this.state.sheight-220}>

                <div className="carcontent">

                  <Row>
                    {!this.state.fullViewInfo && <Col xs={this.state.selectedSchedulerId !==undefined ? "6":"12"}>
                      <Card>
                        <CardBody>
                      <Row className="headerScheduler">
                            <Col xs="2">
                              <span title="Name" className="overflowStyle" style={{fontSize:13}}>Name</span>
                            </Col>
                            <Col xs="2">
                                <span title="Description" className="overflowStyle" style={{fontSize:13}}>Description</span>
                            </Col>
                            <Col xs="2">
                                <span title="Status" className="overflowStyle" style={{fontSize:13}}>Status</span>
                            </Col>
                            <Col xs="1">
                                <span title="Scheduled For" className="overflowStyle" style={{fontSize:13}}>Scheduled For</span>
                            </Col>
                            <Col xs="1">
                                <span title="Type" className="overflowStyle" style={{fontSize:13}}>Type</span>
                            </Col>
                            <Col xs="2">
                                <span title="Triggered Info" className="overflowStyle" style={{fontSize:13}}>Triggered Info</span>
                            </Col>
                            <Col xs="1">
                                <span title="Created By" className="overflowStyle" style={{fontSize:13}}>Created By</span>
                            </Col>
                            <Col xs="1" style={{textAlign:"end"}}>
                                <span style={{fontSize:13}}></span>
                            </Col>
                      </Row>

                      <Scrollbars autoHeight autoHeightMin={this.state.sheight-220}>
                        <ListGroup className="scheduler-content">
                        {this.state.schedulerData.map((item, index) => (<ListGroupItem 
                        key={uuidv4()}
                        className={this.state.selectedSchedulerId === item.id ? "schedulerActive":""}
                        onMouseEnter={e => this.onMouseHoverScheduler(item.id)}
                        onClick={e=> this.onSchedulerRowClick(item.id)}>
                          <Row style={{cursor:"pointer"}}>
                            <Col xs="2" className="d-flex align-items-baseline">
                            <span className="actionicon" title="Show Runs" onClick={e=>this.onExpandRunDetails(item.id)}> 
                            <i className="fas fa-external-link-alt mr-1 fa-sm" style={{color:'#007bff'}}/> &nbsp;</span>
                                <span title={item.name} className="overflowStyle" style={{fontSize:13}}>{item.name}</span>
                            </Col>
                            <Col xs="2">
                                <span title={item.description} className="overflowStyle" style={{fontSize:13}}>{item.description}</span>
                            </Col>
                            <Col xs="2">  

                             {item.scheduleStatus === "SCHEDULE_PENDING" && <span title={convertTextToTitleCase(this.schedulerStatusReplaceWithHypen(item.scheduleStatus))} className="overflowStyle"><Badge color="" className="badge-dot"><i className="bg-yellow" />{convertTextToTitleCase(item.scheduleStatus)}</Badge></span>}
                               {item.scheduleStatus === "SCHEDULING" && <span title={convertTextToTitleCase(item.scheduleStatus)} className="overflowStyle"><Badge color="" className="badge-dot"><i className="bg-yellow blink" />{convertTextToTitleCase(item.scheduleStatus)}</Badge></span>}
                               {item.scheduleStatus === "SCHEDULED" && <span title={convertTextToTitleCase(item.scheduleStatus)} className="overflowStyle"><Badge color="" className="badge-dot"><i className="bg-green" />{convertTextToTitleCase(item.scheduleStatus)}</Badge></span>}
                               {item.scheduleStatus === "FINISHED" && <span title={convertTextToTitleCase(item.scheduleStatus)} className="overflowStyle"><Badge color="" className="badge-dot"><i className="bg-blue" />{convertTextToTitleCase(item.scheduleStatus)}</Badge></span>}
                               {item.scheduleStatus === "CANCEL_PENDING" && <span title={convertTextToTitleCase(this.schedulerStatusReplaceWithHypen(item.scheduleStatus))} className="overflowStyle"><Badge color="" className="badge-dot"><i className="bg-darkgray" />{convertTextToTitleCase(item.scheduleStatus)}</Badge></span>}
                               {item.scheduleStatus === "CANCELLING" && <span title={convertTextToTitleCase(item.scheduleStatus)} className="overflowStyle"><Badge color="" className="badge-dot"><i className="bg-darkgray blink" />{convertTextToTitleCase(item.scheduleStatus)}</Badge></span>}
                               {item.scheduleStatus === "CANCELLED" && <span className="overflowStyle">
                                 <Badge color="" className="badge-dot"><i className="bg-darkgray" />{convertTextToTitleCase(item.scheduleStatus)}</Badge>
                                {item.message !== null && <span title={item.message}><i className="fas fa-info-circle p-2"></i></span>}
                               </span>
                               }
                               {item.scheduleStatus === "FAILED" && <span title={convertTextToTitleCase(item.scheduleStatus)} className="overflowStyle"><Badge color="" className="badge-dot"><i className="bg-red" />{convertTextToTitleCase(item.scheduleStatus)}</Badge></span>}
                               {item.scheduleStatus === "ERROR" && <span title={convertTextToTitleCase(item.scheduleStatus)} className="overflowStyle"><Badge color="" className="badge-dot"><i className="bg-red" />{convertTextToTitleCase(item.scheduleStatus)}</Badge></span>}
                             
                            </Col>
                            <Col xs="1">
                                {item.scheduleItem !== null && <Row style = {{marginLeft:10}}>
                                  {item.scheduleItem.type === "RUN" && <i className="fas fa-running" style={{color:"#4284f3"}}></i>}
                                  &nbsp;&nbsp;<span title={item.scheduleItem.type} className="overflowStyle" style={{fontSize:13}}>{convertTextToTitleCase(item.scheduleItem.type)}</span></Row>}
                            </Col>
                            <Col xs="1">
                                <span title={item.scheduleType} className="overflowStyle" style={{fontSize:13}}>{item.scheduleType}</span>
                            </Col>
                            <Col xs="2" className="triggerInfoItem">
                              <span title={item.lastTriggeredAt !== null ? moment(item.lastTriggeredAt).format("MMM DD, YYYY HH:mm") : "---"}>Last Event &nbsp;&nbsp;: {item.lastTriggeredAt !== null ? moment(item.lastTriggeredAt).format("MMM DD, YYYY HH:mm") : "---"}</span><br/>
                              <span title={item.nextTriggerAt !== null ? moment(item.nextTriggerAt).format("MMM DD, YYYY HH:mm") : "---"}>Next Event &nbsp;&nbsp;:{item.nextTriggerAt !== null ? <span style={{color:"#4285f4",fontWeight:600}}>&nbsp;{moment(item.nextTriggerAt).format("MMM DD, YYYY HH:mm")}</span> : "    ---"}</span>

                            </Col>
                            <Col xs="1">
                                {/* <span title={item.createdBy} className="overflowStyle" style={{fontSize:13}}>{getProfilePicturebyEmail(item.userId, this.state.userList)}</span> */}
                                <span title={item.createdBy} className="overflowStyle" style={{fontSize:13}}>{item.createdBy}</span>
                            </Col>
                            <Col xs="1" style={{textAlign:"end"}}>
                              {this.state.mouseHoverScheduler === item.id &&  <i className="fas fa-arrow-alt-circle-right"></i>}
                            </Col>
                          </Row>
                        </ListGroupItem>))}

                        {this.state.schedulerData.length === 0 && <Col>
                          <div style={{ justifyContent: "center", textAlign: "center",marginTop:"3%" }}>
                            <span>No Scheduler Found <span className="text-primary font-italic pointer-cursor" onClick={e=>this.movetoCreateScheduler()}>Create Scheduler</span></span>
                          </div>
                        </Col>
                        }
                        </ListGroup>
                      </Scrollbars>
                      <Pagination 
                         pages= {this.state.totalPages}
                         page={this.state.currentPageNumber}
                         onPageChange={this.onPageChange}
                         previousText="Previous"
                         nextText="Next"
                        />
                        </CardBody>
                      </Card>
                    </Col>}

                    {(this.state.selectedSchedulerId !== undefined) && <Col xs={(this.state.selectedSchedulerId !== undefined) && (this.state.fullViewInfo === true) ? "12":"6"}>
                    {/* <Scrollbars autoHeight autoHeightMin={450}> */}
                      <Card>
                        <CardBody>
                          {this.state.loadingFlag !== "" && <div style={{textAlign:"center"}}>
                          <Badge color="info"> {this.state.loadingFlag} </Badge>
                          </div>}
                          <Row>
                            <Col>
                            <span style={{fontSize:16,fontWeight:600}}>Scheduler Info</span><br/>
                            {/* <span style={{fontSize:13,color:"#6e6e6e"}}>{this.state.schedulerDataById.length !== 0 ? "Created By : " +this.state.schedulerDataById[0].createdBy : "" }</span> */}
                            </Col>
                            <Col style={{textAlign:"end"}}>
                            <span className="actionicon" > <i className="fas fa-times" style={{float:"right"}} onClick={e=> this.onSchedulerRowClick()}/> &nbsp;</span> 
                            </Col>
                          </Row>
                          <hr/>
                          <Row style={{marginLeft: 0,justifyContent:"flex-end"}}>
                              <span className="actionicon" id={'expandScheduler'+0} onClick={e=>this.onExpandRunDetails(this.state.selectedSchedulerId)}> <i className="fas fa-external-link-alt mr-2" style={{color:'#007bff'}}/> &nbsp;</span> 
                                <UncontrolledTooltip placement="top" target={'expandScheduler'+0} delay={0}>
                                    Show Runs
                                </UncontrolledTooltip>
                                <span className="actionicon" id={'editScheduler'+0} onClick={e=>this.onEditScheduler()}> <i className="far fa-edit mr-2" style={{color:'#007bff'}}/> &nbsp;</span> 
                                <UncontrolledTooltip placement="top" target={'editScheduler'+0} delay={0}>
                                    Edit Scheduler
                                </UncontrolledTooltip>
                              <span className="actionicon" id={'cancelScheduler'+1} onClick={e=>this.onCancelSchedulerConfirmation()}> 
                                <i className="far fa-calendar-times text-red mr-2" style={{color:'#007bff'}}/> &nbsp;</span> 
                                <UncontrolledTooltip placement="top" target={'cancelScheduler'+1} delay={0}>
                                Cancel Scheduler
                                </UncontrolledTooltip>                       
                          </Row> 
                            <SchedulerNoPopup
                            SchedulerMode="Update"
                            EditFlag={this.state.editFlag}
                            schedulerDataById={this.state.schedulerDataById}
                            // SchedulerId={this.state.selectedSchedulerId}
                            SchedulerUpdate={this.UpdateScheduleProject}
                            ScheduleType={"Run"}
                          />
                        </CardBody>
                      </Card>
                      {/* </Scrollbars> */}
                    </Col>}
                  </Row>
            {/* <ReactTable
         data={ this.state.schedulerData }
         columns={ this.state.columns }
         defaultPageSize={10}
         showPaginationBottom={true}
         className="-striped -highlight Providerstable"
          /> */}

</div>
</Scrollbars>
                </CardBody>
              </Card>
            </Col>
          </Row>
          {/* {this.state.showScheduler && <Scheduler
              ShowScheduler={this.state.showScheduler}
              ToggleScheduler={this.toggleScheduler}
              SchedulerMode="Update"
              SchedulerId={this.state.SchedulerId}
              SubmitScheduler={this.SubmitScheduleProject}
              ProjectName=""
              ScheduleType={"Run"}
            />} */}
      </LoadingOverlay>

        </div>
      </>
    );
  }
}

export default SchedulerList;